// eslint-disable-next-line lodash/prefer-constant
export const getInstallationTimeAsync = async () => null;
